<template>
  <li><a @click="deleteReport()">Delete Report</a></li>
</template>

<script>
import { ReportWizard } from '../../api';
import { mapState, mapGetters } from 'vuex';
import store from '../../store.js';
import { bus } from '../../main';
import Vue from 'vue';
import constants from '../../constants.js';
import Popups from '../Popups';
export default {
    data () {
        return {
            errors: [],
            hasChanges: false,
            message: { type: 'warning', title: 'Report' },
        }
    },
    computed: {
        ...mapGetters([ 'getErrors', 'getErrors' ]),
        ...mapState({
            selectedReport: function(state) {
              return state.selectedReport;
            },
        }),
    },
    methods: {
        reset: function() {
          this.errors = [];
          bus.$emit('reset', {});
        },
        
        redirect: function(action) {
          if (action == 'success') this.$router.push('/reports');
        },

        showPopup: function(value, type) {
          bus.$emit(type, { data: value });
          this.redirect(value.type);
        },

        confirmAction: function(data, action) {
          this.$confirm({
              title: 'Confirm Action',
              content: constants.message[action].action,
            }).then(() => {
              this.actionReport(data, action)
              }).catch(() => {
                this.$notify('Request has been cancelled.')
              });
        },

        actionReport: async function(data, action) {
            let failed = constants.message[action].failed;
            let success = constants.message[action].success;

            let response = await store.dispatch('deleteSelectedReport', { id: this.$route.params.id }); 

            if(response === 'success' || response != undefined){
                this.message.type = 'success';
                this.message.content = success;
            } else {
                this.message.type = 'warning';
                this.message.content = failed;
            }
          
            this.showPopup(this.message, 'notification');
        },

        deleteReport: function () {
          let selectedReport = this.selectedReport;
          this.confirmAction(selectedReport, 'delete');
        },
    },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/report/ReportDelete.vue